// Fichier : pages/Admin/ModifierArticle.js
import React, { useEffect, useState } from 'react';
import api from '../../api';
import RichTextEditor from '../../components/RichTextEditor';
import './AdminArticles.css';

const ModifierArticle = () => {
  const [articles, setArticles] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    imageUrl: '',
    publicId: ''
  });
  const [newImageBase64, setNewImageBase64] = useState(null);

  useEffect(() => {
    api.get('/articles').then(res => setArticles(res.data));
  }, []);

  const handleSelect = (id) => {
    const article = articles.find(a => a._id === id);
    setSelectedId(id);
    setFormData({
      title: article.title,
      content: article.content,
      imageUrl: article.imageUrl || '',
      publicId: article.publicId || ''
    });
    setNewImageBase64(null);
  };

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleImageChange = (e) => {
    const reader = new FileReader();
    reader.onloadend = () => setNewImageBase64(reader.result);
    if (e.target.files[0]) reader.readAsDataURL(e.target.files[0]);
  };

  const handleUpdate = async () => {
    try {
      let updatedImageUrl = formData.imageUrl;
      let updatedPublicId = formData.publicId;

      if (newImageBase64) {
        const blob = await fetch(newImageBase64).then(res => res.blob());
        const form = new FormData();
        form.append('image', blob, 'image.jpg');

        //const uploadRes = await api.post('/upload', form);
        const uploadRes = await api.post('/upload/single', form, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        updatedImageUrl = uploadRes.data.url;
        updatedPublicId = uploadRes.data.public_id;
      }

      const updatedData = {
        ...formData,
        imageUrl: updatedImageUrl,
        publicId: updatedPublicId
      };

      await api.put(`/articles/${selectedId}`, updatedData);
      alert('Article modifié avec succès');
    } catch (err) {
      alert('Erreur lors de la modification');
      console.error(err);
    }
  };

  return (
    <div className="admin-page">
      <h2>Modifier un article</h2>

      <select onChange={(e) => handleSelect(e.target.value)}>
        <option value="">-- Sélectionner un article --</option>
        {articles.map(a => (
          <option key={a._id} value={a._id}>{a.title}</option>
        ))}
      </select>

      {selectedId && (
        <>
          <input
            name="title"
            placeholder="Titre"
            value={formData.title}
            onChange={handleChange}
          />

          <RichTextEditor
            value={formData.content}
            onChange={(value) => setFormData(prev => ({ ...prev, content: value }))}
            placeholder="Contenu de l'article"
          />

          <input type="file" onChange={handleImageChange} />

          {formData.imageUrl && (
            <div style={{ marginTop: '10px' }}>
              <p>Image actuelle :</p>
              <img src={formData.imageUrl} alt="Aperçu" style={{ maxWidth: '300px' }} />
            </div>
          )}

          <button onClick={handleUpdate}>Mettre à jour</button>
        </>
      )}
    </div>
  );
};

export default ModifierArticle;
